import React from "react";
import { LogoStyled } from "./styles/Styled";

export default ({ height }) => {
  return (
    <LogoStyled
      src={"https://starzplay-img-prod-ssl.akamaized.net/prd-peg-data/default/images/logos/admn/tvs/admn-logo.svg"}
      alt="Logo"
      height={height}
    />
  );
};
